
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class PrintBtn extends Vue {
  @Prop(Boolean) public disabled: boolean;
  @Prop(Boolean) public isLoading: boolean;

  public handleClick() {
    this.$emit('click');
  }
}
